import { useEffect } from "react";

// Keeps private pages out of search engines while mounted.
export const useNoIndex = () => {
  useEffect(() => {
    let m = document.querySelector('meta[name="robots"]');
    const created = !m;
    if (created) {
      m = document.createElement("meta");
      m.name = "robots";
      document.head.appendChild(m);
    }
    const prev = m.content;
    m.content = "noindex, nofollow";
    return () => { if (created) m.remove(); else m.content = prev; };
  }, []);
};
